import type { TOC } from '@ember/component/template-only';
import { hash } from '@ember/helper';
import { PrismIcon } from '@mylighthouse/prism-ember';
// @ts-expect-error: Incorrect type
import DraggableObject from 'ember-drag-drop/components/draggable-object';

interface SettingsRecommendationsCompetitorsImpactDragHandleSignature {
  Args: {
    id: string;
    isEditMode: boolean;
    title: string;
  };
}

const SettingsRecommendationsCompetitorsImpactDragHandle = <template>
  {{#if @isEditMode}}
    <DraggableObject @content={{hash id=@id title=@title}}>
      <div
        class="drag-handle drag-handle--draggable inline-flex items-center gap-100"
      >
        <div class="mr-50 ml-50">
          <PrismIcon @name="drag" @size="small" />
        </div>
        <p class="text-300--regular mt-100 mr-200 mb-100">{{@title}}</p>
      </div>
    </DraggableObject>
  {{else}}
    <div class="drag-handle inline-flex items-center">
      <p class="text-300--regular mt-100 mr-400 mb-100 ml-400">{{@title}}</p>
    </div>
  {{/if}}
</template> satisfies TOC<SettingsRecommendationsCompetitorsImpactDragHandleSignature>;

export default SettingsRecommendationsCompetitorsImpactDragHandle;
